module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Period Between Two Dates",
      "icon": "period-dates"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "label": "First Date",
      "no-flex-margin": true
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin-slight flex-grid--wrap"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:first_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "first_date",
      modifiers: {
        "required": true
      }
    }],
    ref: "firstDate",
    on: {
      "input": _vm.calculate
    },
    model: {
      value: (_vm.firstDate),
      callback: function($$v) {
        _vm.firstDate = $$v
      },
      expression: "firstDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('first_date')
    }
  }, [_vm._v("\n                        The first date is required in the format DD/MM/YYYY\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "a-checkbox u-margin-tb-10-30"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.includeFirstDay),
      expression: "options.includeFirstDay"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.includeFirstDay) ? _vm._i(_vm.options.includeFirstDay, null) > -1 : (_vm.options.includeFirstDay)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.options.includeFirstDay,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.options, "includeFirstDay", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.options, "includeFirstDay", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.options, "includeFirstDay", $$c)
        }
      }, _vm.updateOptions]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Include first day")])])], 1)]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Second Date",
      "no-flex-margin": true
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-bottom-margin-slight flex-grid--wrap"
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:second_date.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "second_date",
      modifiers: {
        "required": true
      }
    }],
    ref: "secondDate",
    on: {
      "input": _vm.calculate
    },
    model: {
      value: (_vm.secondDate),
      callback: function($$v) {
        _vm.secondDate = $$v
      },
      expression: "secondDate"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('second_date')
    }
  }, [_vm._v("\n                        The second date is required in the format DD/MM/YYYY\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "a-checkbox u-margin-tb-10-30"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.includeLastDay),
      expression: "options.includeLastDay"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.includeLastDay) ? _vm._i(_vm.options.includeLastDay, null) > -1 : (_vm.options.includeLastDay)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.options.includeLastDay,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.options, "includeLastDay", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.options, "includeLastDay", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.options, "includeLastDay", $$c)
        }
      }, _vm.updateOptions]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Include last day")])])], 1)]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "precision",
      "label": "Precision"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.dp),
      expression: "options.dp"
    }],
    attrs: {
      "name": "precision",
      "id": "precision"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.options, "dp", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calculate]
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Bank Holidays:",
      "no-flex-margin": true
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-margin-bottom flex-grid--wrap"
  }, [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.includeBankHolidays),
      expression: "options.includeBankHolidays"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.includeBankHolidays) ? _vm._i(_vm.options.includeBankHolidays, null) > -1 : (_vm.options.includeBankHolidays)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.options.includeBankHolidays,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.options, "includeBankHolidays", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.options, "includeBankHolidays", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.options, "includeBankHolidays", $$c)
        }
      }, _vm.updateOptions]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Include bank holidays")])])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Weekends:",
      "no-flex-margin": true
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-margin-bottom flex-grid--wrap"
  }, [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.includeWeekends),
      expression: "options.includeWeekends"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.includeWeekends) ? _vm._i(_vm.options.includeWeekends, null) > -1 : (_vm.options.includeWeekends)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.options.includeWeekends,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.options, "includeWeekends", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.options, "includeWeekends", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.options, "includeWeekends", $$c)
        }
      }, _vm.updateOptions]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Include Weekends")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Display Options:",
      "no-flex-margin": true
    }
  }, [_c('div', {
    staticClass: "flex-grid flex-grid--reduced-margin-bottom flex-grid--wrap flex-grid--row"
  }, [_c('div', {
    staticClass: "p-animated-calc--half p-animated-calc--half-non-block"
  }, [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.show.years),
      expression: "options.show.years"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.show.years) ? _vm._i(_vm.options.show.years, null) > -1 : (_vm.options.show.years)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.options.show.years,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.options.show, "years", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.options.show, "years", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.options.show, "years", $$c)
        }
      }, _vm.updateOptions]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Years")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc--half p-animated-calc--half-non-block"
  }, [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.show.months),
      expression: "options.show.months"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.show.months) ? _vm._i(_vm.options.show.months, null) > -1 : (_vm.options.show.months)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.options.show.months,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.options.show, "months", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.options.show, "months", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.options.show, "months", $$c)
        }
      }, _vm.updateOptions]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Months")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc--half p-animated-calc--half-non-block"
  }, [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.show.weeks),
      expression: "options.show.weeks"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.show.weeks) ? _vm._i(_vm.options.show.weeks, null) > -1 : (_vm.options.show.weeks)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.options.show.weeks,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.options.show, "weeks", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.options.show, "weeks", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.options.show, "weeks", $$c)
        }
      }, _vm.updateOptions]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Weeks")])])]), _vm._v(" "), _c('div', {
    staticClass: "p-animated-calc--half p-animated-calc--half-non-block"
  }, [_c('div', {
    staticClass: "a-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.options.show.days),
      expression: "options.show.days"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.show.days) ? _vm._i(_vm.options.show.days, null) > -1 : (_vm.options.show.days)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.options.show.days,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.options.show, "days", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.options.show, "days", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.options.show, "days", $$c)
        }
      }, _vm.updateOptions]
    }
  }), _vm._v(" "), _c('label', [_vm._v("Days")])])])])]), _vm._v(" "), (_vm.diffBetween) ? _c('h2', [_vm._v("\n                Result\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex-grid p-animated-calc--full-width flex-grid--row"
  }, [_c('div', {
    staticClass: "p-animated-calc--full-width"
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "type": "text ",
      "disabled": ""
    },
    domProps: {
      "value": _vm.diffBetween
    }
  })])]), _vm._v(" "), (_vm.optionsEmpty()) ? _c('div', [_vm._v("\n                Please make sure you have selected display options...\n            ")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResults),
      expression: "showResults"
    }],
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("\n                Explanation\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                The duration between "), _c('strong', [_vm._v(_vm._s(_vm.firstDate))]), _vm._v(" and "), _c('strong', [_vm._v(_vm._s(_vm.secondDate))]), _vm._v("\n                has been calculated.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                During the period "), _c('strong', [_vm._v(_vm._s(_vm.options.numberOfBankHolidays))]), _vm._v(" number of bank holidays would have\n                occurred. These have been "), (_vm.options.includeBankHolidays) ? _c('span', [_vm._v(" included")]) : _c('span', [_vm._v(" removed")]), _vm._v(" from the calculated total.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                During the period "), _c('strong', [_vm._v(_vm._s(_vm.options.numberOfWeekendDays))]), _vm._v(" number of weekend days would have\n                occurred. These have been "), (_vm.options.includeWeekends) ? _c('span', [_vm._v(" included")]) : _c('span', [_vm._v(" removed")]), _vm._v(" from the calculated total.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                The total difference between the two dates is:\n                "), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "flex-grid p-animated-calc--full-width flex-grid--row p-period-between"
  }, [(_vm.options.show.years && !_vm.options.show.months && !_vm.options.show.weeks && !_vm.options.show.days) ? _c('div', [_c('span', {
    staticClass: "p-period-between__period-result"
  }, [_c('span', {
    staticClass: "u-bold"
  }, [_vm._v(_vm._s(_vm.diffYears))])])]) : _c('div', [_c('span', {
    staticClass: "p-period-between__period-result"
  }, [_c('span', {
    staticClass: "u-bold"
  }, [_vm._v(_vm._s(_vm.diffBetween))])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bf64a880!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/calculators/periodBetweenTwoDates.vue
// module id = 1800
// module chunks = 0